import { render, staticRenderFns } from "./IconCommentOutline.vue?vue&type=template&id=2923846d&scoped=true&"
import script from "./IconCommentOutline.vue?vue&type=script&lang=js&"
export * from "./IconCommentOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923846d",
  null
  
)

export default component.exports